
import { supabase } from '@/integrations/supabase/client';
import { toast } from "sonner";

export const useTrackNotification = () => {
  /**
   * Sends a notification email when a track is uploaded
   */
  const sendTrackNotificationEmail = async (trackId: string, email?: string) => {
    if (!trackId) {
      console.error('Track notification failed: Missing trackId');
      return { success: false, error: 'Missing trackId' };
    }
    
    console.log('🔔 Attempting to send track notification email for:', { trackId, email });
    
    try {
      // Use a direct URL to ensure the Edge Function is called properly
      const url = 'https://ovklrhkrsodpunvdyebr.supabase.co/functions/v1/track-upload-notification';
      console.log('⚡ Calling function at URL:', url);
      
      // Get the user's session
      const { data: sessionData } = await supabase.auth.getSession();
      const token = sessionData.session?.access_token;
      
      // Prepare payload (include email if provided)
      const payload: { trackId: string, email?: string } = { trackId };
      if (email) {
        payload.email = email;
      }
      
      const { data, error } = await supabase.functions.invoke('track-upload-notification', {
        body: payload
      });
      
      // Fall back to direct fetch if invoke method fails silently
      if (!data && !error) {
        console.log('⚠️ Supabase functions.invoke returned no data and no error. Trying direct fetch...');
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token || ''}`,
            'apikey': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im92a2xyaGtyc29kcHVudmR5ZWJyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE4NTMwMzcsImV4cCI6MjA1NzQyOTAzN30.Z71lKqivxDVsHp0_kWyhKetlwEUn8o-42JLIyv-SuZg'
          },
          body: JSON.stringify(payload)
        });
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('❌ Direct fetch failed:', response.status, errorText);
          toast.error("Failed to send notification email");
          return { success: false, error: `HTTP error: ${response.status}` };
        }
        
        const resultData = await response.json();
        console.log('✅ Track notification email sent successfully via direct fetch:', resultData);
        toast.success("Track notification email sent");
        return { success: true, data: resultData };
      }
      
      if (error) {
        console.error('❌ Error sending notification email:', error);
        toast.error("Failed to send notification email");
        return { success: false, error };
      } else {
        console.log('✅ Track notification email sent successfully:', data);
        toast.success("Track notification email sent");
        return { success: true, data };
      }
    } catch (err) {
      console.error('❌ Exception while sending track notification email:', err);
      toast.error("Failed to send notification email");
      return { success: false, error: err };
    }
  };

  return { sendTrackNotificationEmail };
};
